import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function RecommendedPrintSizeBadge({ className }) {
  return (<span className={classNames('badge badge-pill badge-primary recommended-print-size-badge', className)}>Recommended</span>);
}

RecommendedPrintSizeBadge.propTypes = {
  className: PropTypes.string,
}

RecommendedPrintSizeBadge.defaultProps = {
  className: null,
}
